import { useEffect, useState } from "react";

import type { PrepareProductLinkOptions } from "./prepareProductLink/prepareProductLink";
import { prepareProductLink } from "./prepareProductLink/prepareProductLink";

export const usePdpLink = (sku: string, options: PrepareProductLinkOptions): string => {
  const [pdpLink, setPdpLink] = useState<string>("");
  const { shopUrl, pdpUrl } = options;

  useEffect(() => {
    prepareProductLink(sku, { shopUrl, pdpUrl }).then(setPdpLink);
  }, [sku, shopUrl, pdpUrl]);

  return pdpLink;
};
